<template>
  <div id="adddevice">
    <v-app>
    <v-container fluid grid-list-lg>
      <v-flex justify-center xs12 sm12 md12>

    <form>
      <v-text-field
      v-model="devicetype"
      :error-messages="errors.collect('devicetype')"
      label="Device Type"
      required
      ></v-text-field>

      <v-btn color="blue lighten-1" type="submit" @click="saveInput" to="/">submit</v-btn>
      <v-btn to="/">Cancel</v-btn>
    </form>
      </v-flex>
  </v-container>
  </v-app>
 </div>
</template>

<script>
import db from './firebaseinit'
export default {
  name: 'adddevice',
  data () {
    return {
      devices: [],
      devicetype: null
    }
  },
  created () {
    db.collection("devices")
      .orderBy("devicetype")
      .get()
      .then(querySnapshot => {
        querySnapshot.forEach(doc => {
          const data = {
            'devicetype': doc.data().devicetype
          };
          this.devices.push(data);
        });
      });
  },
  methods: {
    saveInput () {
      db.collection('devices').add({
        devicetype: this.devicetype
      })
      .then(docRef => this.$router.push('/'))
        .catch(error => console.log(err))
        alert('Device Type created');
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/AddDevice.vue